import React from 'react';

function MinimizeIcon({ color = '#0070F0' }) {
  return (
    <svg width='19' height='3' viewBox='0 0 19 3' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.7824 3H2.29728C1.07318 3 0.0797119 2.328 0.0797119 1.5C0.0797119 0.672 1.07318 0 2.29728 0H16.7824C18.0065 0 19 0.672 19 1.5C19 2.328 18.0065 3 16.7824 3Z'
        fill={color}
      />
    </svg>
  );
}
export default MinimizeIcon;
